export default {
  collect (h, conf, key) {
    const list = []
    conf.topicData.collect.forEach(item => {
      if (conf.__config__.optionType === 2) {
        list.push(
          <el-checkbox-button
            label={item.value}
            disabled={item.disabled}
          >{item.label}</el-checkbox-button>
        )
      } else {
        list.push(
          <el-checkbox
            class="qn-custom-vertical"
            label={item.value}
            disabled={item.disabled}
          >{item.label}</el-checkbox>
        )
      }
    })
    return list
  }
}
